import { AfterContentInit, Directive, ElementRef, Input, inject } from '@angular/core';

@Directive({
  selector: '[autoFocus]',
  standalone: false
})
export class AutofocusDirective implements AfterContentInit {
  private el = inject(ElementRef);

  private _autofocus;

  @Input() set autoFocus(condition: boolean) {
    this._autofocus = condition != false;
  }


  public constructor() { }

  public ngAfterContentInit() {
    if (this._autofocus || typeof this._autofocus === 'undefined') {
      setTimeout(() => this.el.nativeElement.focus());
    }
  }
}
